import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import SoftwareVersion from '../../../models/enums/software-version';
import { stringToColor } from '../../../utils/avatarStyles';

const SoftwareVersionIndicator: React.FC<{ softwareVersion: SoftwareVersion }> = ({
  softwareVersion,
}) => {
  return (
    <Tooltip title={softwareVersion} placement="left">
      <Box
        sx={(theme) => ({
          height: theme.spacing(2),
          backgroundColor: stringToColor(softwareVersion),
          width: theme.spacing(2),
          borderRadius: theme.spacing(1),
          overflow: 'hidden',
        })}
      >
        <Box sx={{ backgroundColor: 'black', width: '100%', opacity: 0.2, height: '100%' }} />
      </Box>
    </Tooltip>
  );
};

export default SoftwareVersionIndicator;
